import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import * as homeActions from '../home/redux/actions';
import i18next from 'i18next';
import { withTranslation } from 'react-i18next';

const partners = [
  { icon: 'googlemaps', title: 'google maps' },
  { icon: 'busbud', title: 'busbud' },
  { icon: 'despegar', title: 'despegar' },
  { icon: 'uber', title: 'uber' },
  { icon: 'bancoestado', title: 'banco estado' },
  { icon: 'caja-vecina', title: 'caja vecina' },
  { icon: 'sencillito', title: 'sencillito' },
  { icon: 'multicaja', title: 'multicaja' },
  { icon: 'los-heroes', title: 'los heroes' },
  { icon: 'caja-18', title: 'caja 18' },
  { icon: 'unired', title: 'unired' },
  { icon: 'puntos', title: 'puntos' },
  { icon: 'corfo', title: 'corfo' },
  { icon: 'microsoft', title: 'microsoft' },
  { icon: 'imagine-lab', title: 'imagine lab' },
  { icon: 'startup-chile', title: 'startup chile' },
];

class Partners extends Component {
  static propTypes = {
    pages: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    console.log('Props in partners', this.props.location.t);
    return (
      <div className=" content-container cancel-done-section pages-partners font10">
        <div className=" page-title font20">
          {/* {this.props.location.t('HOME.WITH_LOVE')} */}
          {i18next.language == 'es' ? (
            <span>
              Nuestras<span className="bold-text">&nbsp;alianzas</span>
            </span>
          ) : (
            <span>
              Our<span className="bold-text">&nbsp;partners</span>
            </span>
          )}
        </div>
        <div className="kupos-card flex-row contact-us-item partners-rows">
          {partners.map((val, key) => (
            <div className="partners-item" key={key}>
              <img
                style={val.icon === 'uber' ? { maxWidth: '40%' } : { maxWidth: '52%' }}
                src={'/static/images/icons/partners/' + val.icon + '.png'}
                alt={val.title}
              />
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default withTranslation('common')(Partners);



// WEBPACK FOOTER //
// ./src/features/pages/Partners.js